module.exports = __webpack_public_path__ + "img/libp2p.6981c428.svg";